import React, { useEffect, useState } from "react";
import { AlertTriangle, ChevronDown } from "lucide-react";
import { api, formatDate } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AttHolidays } from "@/components/AttHolidays";

export function PendingAttendance({ onPick, refreshKey }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/teacher/attendance-missing", { params: { days: 7 } }).then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, [refreshKey]);
  if (!items) return null;
  if (!items.length) return <div className="text-xs text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2" data-testid="pending-att-none">All attendance for the last 7 days is taken.</div>;
  return (
    <div className="rounded-2xl border border-red-200 bg-red-50 p-4" data-testid="pending-att">
      <p className="font-semibold text-red-800 flex items-center gap-2 text-sm"><AlertTriangle className="h-4 w-4" /> Attendance not taken ({items.length})</p>
      <p className="text-xs text-red-700 mb-2">Tap to open and mark it. If it was a holiday, mark the holiday below.</p>
      <div className="flex flex-wrap gap-1.5">
        {items.map((i) => (
          <button key={`${i.date}-${i.klass}`} type="button" onClick={() => onPick(i.date, i.klass)} data-testid={`pending-att-${i.date}-${i.klass}`}
            className="rounded-full bg-white px-3 py-1 text-xs font-semibold text-red-700 ring-1 ring-red-200 hover:bg-red-100 transition-colors">
            {formatDate(i.date)} · {i.klass}
          </button>
        ))}
      </div>
    </div>
  );
}

export function TeacherHolidays({ classes, onChanged }) {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between text-sm font-semibold text-slate-800" data-testid="teacher-holidays-toggle">
        Mark a holiday for my class <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="mt-3"><AttHolidays isAdmin={false} classes={classes} myId={user?.id} onChanged={onChanged} /></div>}
    </div>
  );
}
